import React from "react";

const Pagination1 = ({ currentPage, totalPages, onPageChange }) => {

    const handlePrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    const handleFirstPage = () => {
        if (currentPage !== 1) {
            onPageChange(1);
        }
    };

    const handleLastPage = () => {
        if (currentPage !== totalPages) {
            onPageChange(totalPages);
        }
    };

    const renderPageNumbers = () => {
        const pages = [];
        const maxPageButtons = 5;
        const shouldShowEllipsis = totalPages > maxPageButtons;

        const getVisiblePages = () => {
            if (!shouldShowEllipsis) return Array.from({length: totalPages}, (_, i) => i + 1);

            if (currentPage <= 3) {
                return [1,2,3,4, "...", totalPages];
            }

            if (currentPage >= totalPages - 2) {
                return ["...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
            }

            return ["...", currentPage - 1, currentPage, currentPage + 1, "...",];
        };

        getVisiblePages().forEach((page, index) => {
            if (page === "...") {
                pages.push(
                    //</span><span key={index} className="relative inline-flex items-center px-4 py-2 text-sm text-gray-500"></span>
                    <span key={`ellipsis-${index}`} className="relative inline-flex items-center px-4 py-2 text-sm text-gray-500">
                        ...
                    </span>
                );
            } else {
                pages.push(
                    <a
                        key={`page-${page}`}
                        //key={page}
                        onClick={() => onPageChange(page)}
                        className={`no-underline relative inline-flex items-center px-4 py-2 text-sm font-semibold ${
                            page === currentPage
                                ? "z-10 bg-indigo-600 text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                : "text-gray-900 ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                        } cursor-pointer`}
                    >
                        {page}
                    </a>
                );
            }
        });

        return pages;
    };

    return (
        <div className="flex items-center justify-between border-t border-gray-200 bg-white py-3 w-full">
            <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                <p className="text-sm text-gray-700">
                    Mostrando página <span className="font-medium">{currentPage}</span> de{" "}
                    <span className="font-medium">{totalPages}</span>
                </p>
            </div>
            <div className="content-end">
                <nav className="isolate inline-flex -space-x-px rounded-md shadow-xs " aria-label="Pagination">
                    <button
                        onClick={handleFirstPage}
                        className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                        disabled={currentPage === 1}
                    >
                        <span className="sr-only">First</span>
                        &laquo;
                    </button>
                    <button
                        onClick={handlePrevious}
                        className="relative inline-flex items-center px-3 py-2 text-gray-700 font-bold ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                        disabled={currentPage === 1}
                    >
                        <span className="sr-only">Previous</span>
                        &lt;
                    </button>
                    {renderPageNumbers()}
                    <button
                        onClick={handleNext}
                        className="relative inline-flex items-center px-3 py-2 text-gray-700 font-bold ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                        disabled={currentPage === totalPages}
                    >
                        <span className="sr-only">Next</span>
                        &gt;
                    </button>
                    <button
                        onClick={handleLastPage}
                        className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                        disabled={currentPage === totalPages}
                    >
                        <span className="sr-only">Last</span>
                        &raquo;
                    </button>
                </nav>
            </div>
        </div>
    );
};

export default Pagination1;
